import { render, staticRenderFns } from "./TrashMenu.vue?vue&type=template&id=30ae4e66&"
import script from "./TrashMenu.vue?vue&type=script&lang=js&"
export * from "./TrashMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports